import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Seller } from './seller.model';
import { SellerService } from './seller.service';
import {User} from '../../shared/user/user.model';
@Injectable()
export class SellerPopupService {
    private isOpen = false;


    seller: Seller;
    constructor (
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private sellerService: SellerService

    ) {}

    open (component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.sellerService.find(id).subscribe(seller => {
                seller.createDate = this.datePipe.transform(seller.createDate, 'yyyy-MM-ddThh:mm');
                this.sellerModalRef(component, seller);
            });
        } else {
            this.seller = new Seller();
            this.seller.owner = new User();
            return this.sellerModalRef( component, this.seller );
        }
    }

    sellerModalRef(component: Component, seller: Seller): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.seller = seller;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/seller/seller-popup.service.ts